import React, { Component } from 'react';
import VacancyCard from '../../components/VacancyCard';
import { FormApplication } from '../../components/Form';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Preloader from '../../components/Preloader';
import ErrorMessage from '../../components/ErrorMessage';
import { HashLink as Link } from 'react-router-hash-link';
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';
import { loadInternshipList } from '../../actions/InternshipListActions';
import { loadInternship } from '../../actions/InternshipActions';
import { loadCities } from '../../actions/CitiesActions';
import scrollFunction from '../../utils/scroll';
import { log } from 'util';

function shuffleArray(array) {
  let i = array.length - 1;
  for (; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
}

class PageInternshipsCard extends Component {
  static requestData(store, match) {
    return requestAll([loadInternshipList, () => loadInternship(match.params.internshipsCard), loadCities], store);
  }

  componentDidMount() {
    this.props.actions.loadInternshipList();
    this.props.actions.loadCities();
    this.props.actions.loadInternship(this.props.match.params.internshipsCard);
  }
  render() {
    const shuffled = shuffleArray(this.props.internshipList);

    if (this.props.hasErrored) {
      return <ErrorMessage/>;
    }

    if (this.props.isLoading) {
       return <Preloader/>;
    }

    return (

      <div>
        <VacancyCard {...this.props} isInternship={true} />
        <div className="container container--indentVertical-xl">
          <div className="row">
            <div className="col col--9 colTablet--12">
              <h1 className="text--hide">Стажировка в ЭР-Телеком</h1>
              <h2 id="toInternshipForm" className="text text--h2 text--top16">Приходите к нам стажироваться</h2>
              <div className="text text--bottom40">Заполните и отправьте краткую анкету соискателя, чтобы мы могли подобрать вам работы и пригласить на собеседование. Или <Link scroll={scrollFunction} to="/vacancies#toSubscribe">подпишитесь на рассылку</Link> и получайте интересующие вас вакансии на почту.</div>
              <FormApplication apiUrl='/internship/create/' cities={this.props.cities} vacancy={this.props.vacancy} internships={true} />
            </div>
            {
              (shuffled && shuffled.length > 1) &&
              <div className="col col--3 colTablet--12">
                <h2 className="text text--h3 text--top16">Другие стажировки</h2>
                <div className="text">
                  {
                    shuffled.slice(0, shuffled.length > 2 ? shuffled.length - 2 : shuffled.length - 1).map((vacancy, index) =>
                      <p key={`vacancy-${index}`}><Link to={`internship${vacancy.id}`}>{vacancy.name}</Link></p>
                    )
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.internshipsCard !== this.props.match.params.internshipsCard) {
      this.props.actions.loadInternship(nextProps.match.params.internshipsCard);
    }
  }
}

const mapStateToProps = (state) => {
  return {
      internshipList: state.internshipList.list,
      cities: state.cities.list,
      vacancy: state.internship.item,
      hasErrored: state.internship.hasErrored,
      isLoading: state.internship.isLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadInternshipList, loadInternship, loadCities }, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageInternshipsCard));



// WEBPACK FOOTER //
// ./src/pages/PageInternshipsCard/index.js